import { FormattedMessage } from "react-intl"
class TransporterTypeSelector extends React.Component {
  render() {
    const radioStyle = {
      opacity: "100",
      height: "15px",
      marginLeft: "20px",
    }

    const { toggleTransporterType, selected } = this.props

    return (
      <div className="form-row">
        <div className="col-sm-3 col-xs-6">
          <div className="btn-product">
            <label>
              <input
                type="radio"
                name="transporterType"
                value="bags"
                style={radioStyle}
                onChange={toggleTransporterType}
                defaultChecked={selected === undefined || selected === "bags"}
              />
              <FormattedMessage id="togo.search_results.options.gobags" />
            </label>
          </div>
        </div>
        <div className="col-sm-3 col-xs-6">
          <div className="btn-product">
            <label>
              <input
                type="radio"
                name="transporterType"
                value="boxes"
                onChange={toggleTransporterType}
                style={radioStyle}
                defaultChecked={selected === "boxes"}
              />
              <FormattedMessage id="togo.search_results.options.goboxes" />
            </label>
          </div>
        </div>
        <div className="cleaner" />
      </div>
    )
  }
}

export default TransporterTypeSelector
